var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.description)?_c('v-row',[_c('v-col',{staticClass:"pa-4 color-1-base",domProps:{"innerHTML":_vm._s(_vm.getDescription)}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }